module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SYNTH1.fd80499a.png";